module.exports = __webpack_public_path__ + "img/map_placeholder.ba08aa8.jpg";